export default "__VITE_ASSET__5f65be49__"